<div>
  <div *ngIf="autoHideContent && !hasActiveChild">
    <ng-content></ng-content>
  </div>
  <div>
    <div
      *ngIf="debug" class="p-2"
      [ngClass]="{ 'click-able': isHover }"
      (mouseenter)="isHover = true"
      (mouseleave)="isHover = false"
      [style.background-color]="routePrimaryColor"
    >
      [{{uid || routePrimaryColor}}, hasActiveChild = {{hasActiveChild}}, route = {{routeUrl}}, depth = {{navDepth}}] Router Outlet Start</div>
    <div [style.background-color]="isHover ? routeHoverBackgroundColor : ''">
      <router-outlet
        (activate)="onChildRouteActivate($event, 'primary')"
        (deactivate)="onChildRouteDeactivate($event,'primary')"
      ></router-outlet>
    </div>
    <div
      *ngIf="debug" class="p-2"
      [ngClass]="{ 'click-able': isHover }"
      (mouseenter)="isHover = true"
      (mouseleave)="isHover = false"
      [style.background-color]="routePrimaryColor"
    >
      [{{uid || routePrimaryColor}}, hasActiveChild = {{hasActiveChild}}, route = {{routeUrl}}, depth = {{navDepth}}] Router Outlet End</div>
  </div>
</div>
